import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";
export function FileUpload({ onUpload, accept, label = "Upload File", busyLabel = "Wird hochgeladen…" }) {
    const inputRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState(null);
    const handleFile = async (file) => {
        setUploading(true);
        setError(null);
        try {
            await onUpload(file);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Upload fehlgeschlagen");
        }
        finally {
            setUploading(false);
            // Allow re-selecting the same file after an error
            if (inputRef.current)
                inputRef.current.value = "";
        }
    };
    return (_jsxs("div", { onDragOver: (e) => { e.preventDefault(); setIsDragging(true); }, onDragLeave: () => setIsDragging(false), onDrop: (e) => {
            e.preventDefault();
            setIsDragging(false);
            const file = e.dataTransfer.files[0];
            if (file)
                handleFile(file);
        }, className: `border-2 border-dashed rounded-lg p-4 text-center transition-colors ${isDragging ? "border-primary bg-primary/5" : error ? "border-destructive" : "border-muted"}`, children: [_jsx("input", { ref: inputRef, type: "file", accept: accept, className: "hidden", onChange: (e) => {
                    const file = e.target.files?.[0];
                    if (file)
                        handleFile(file);
                } }), _jsxs(Button, { variant: "outline", size: "sm", disabled: uploading, onClick: () => inputRef.current?.click(), children: [_jsx(Upload, { className: "mr-2 h-4 w-4" }), uploading ? busyLabel : label] }), error ? (_jsx("p", { role: "alert", className: "text-xs text-destructive mt-2", children: error })) : (_jsx("p", { className: "text-xs text-muted-foreground mt-2", children: "oder per Drag & Drop" }))] }));
}
